import { render, staticRenderFns } from "./MonoYoutubeIcon.vue?vue&type=template&id=2a5ea381&scoped=true"
import script from "./MonoYoutubeIcon.vue?vue&type=script&lang=js"
export * from "./MonoYoutubeIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a5ea381",
  null
  
)

export default component.exports